/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { useUnstyled as s, uGrid as t, classNames as l } from "@progress/kendo-react-common";
import * as i from "react";
const d = (a) => {
  const e = s(), r = e && e.uGrid ? e.uGrid : t;
  return /* @__PURE__ */ i.createElement("td", { className: l(r.hierarchyTd({})), role: "gridcell" });
};
export {
  d as GridDetailHierarchyCell
};
